import React from "react";
import Hero from "../../components/hero/Hero";
import WhyChoose from "../sections/WhyChoose";
import FeaturedMeals from "../../components/sections/FeaturedMeals";
import Steps from "../../components/sections/Steps";
import WhatSay from "../../components/sections/WhatSay";
import Footer from "../../components/layout/Footer";
import Navbar from "./Navbar";

export default function MobileView() {
  return (
    <div className="mobile-container">
    <Navbar/>
      <Hero />
      <WhyChoose />
      <FeaturedMeals />
      <Steps />
      <WhatSay />
      <Footer />
      <style>{`
        /* Ensure padding and alignment for smaller screens */
        .mobile-container {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        /* Headings & text */
        .mobile-container h1,
        .mobile-container h2,
        .mobile-container h3 {
          font-size: clamp(1.2rem, 4vw, 2rem);
          text-align: center;
          margin-bottom: 1rem;
        }

        /* Images scaling */
        .mobile-container img {
          max-width: 100%;
          height: auto;
        }

        /* Sections padding */
        .mobile-container section {
          padding: 1.5rem 1rem;
        }

        /* Adjust grid layouts to stack */
        @media (max-width: 768px) {
          .mobile-container .grid {
            grid-template-columns: 1fr !important;
            gap: 1rem;
          }
        }

        /* Buttons */
        .mobile-container button {
          width: 100%;
          padding: 0.75rem;
          font-size: 1rem;
          border-radius: 0.5rem;
        }
      `}</style>
    </div>
  );
}
